<template>
  <v-container>
    <v-app-bar color="primary" short app>
      <v-btn fab small to="/" color="secondary">
        <v-icon color="white" alt="Accueil">home</v-icon>
      </v-btn>
      <v-app-bar-title
        v-if="!$vuetify.breakpoint.smAndDown"
        class="white--text custom_title ml-2"
        >Morfetik</v-app-bar-title
      >
      <v-spacer />
      <span v-if="!$vuetify.breakpoint.smAndDown">
        <v-btn
          class="mr-3"
          rounded
          color="primary darken-1"
          v-for="navigationLink in navigationLinks"
          :key="navigationLink.title"
          :to="navigationLink.link"
          :alt="navigationLink.title"
        >
          <v-icon v-if="navigationLink.icon" left>
            {{ navigationLink.icon }}
          </v-icon>
          {{ navigationLink.title }}
        </v-btn>
      </span>
      <span v-else>
        <v-btn
          class="mr-2"
          rounded
          color="primary darken-1"
          v-for="navigationLink in navigationLinks"
          :key="navigationLink.title"
          :to="navigationLink.link"
          :alt="navigationLink.title"
        >
          <v-icon v-if="navigationLink.icon">
            {{ navigationLink.icon }}
          </v-icon>
        </v-btn>
      </span>
      <v-btn
        v-if="!currentUser && !$vuetify.breakpoint.smAndDown"
        to="/login"
        color="secondary"
      >
        <v-icon left>login</v-icon>
        Se connecter
      </v-btn>
      <v-btn
        v-if="!currentUser && $vuetify.breakpoint.smAndDown"
        to="/login"
        color="secondary"
      >
        <v-icon>login</v-icon>
      </v-btn>
      <v-menu
        v-if="currentUser"
        offset-y
        origin="top center"
        transition="scale-transition"
        bottom
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="!$vuetify.breakpoint.smAndDown"
            v-bind="attrs"
            v-on="on"
            color="secondary"
          >
            <v-icon left>person</v-icon>
            {{ currentUser.username }}
          </v-btn>
          <v-btn v-else v-bind="attrs" v-on="on" color="secondary">
            <v-icon>person</v-icon>
          </v-btn>
        </template>
        <v-list nav class="text-left">
          <v-list-item v-for="(item, i) in items" :key="i" :to="item.link" link>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
          </v-list-item>
          <v-list-item to="/users" v-if="isAdmin">
            <v-list-item-title class="mr-2"
              >Gestion des utilisateurs</v-list-item-title
            >
            <v-icon>people</v-icon>
          </v-list-item>
          <v-list-item to="/edition" v-if="isEditor">
            <v-list-item-title>Édition</v-list-item-title>
            <v-icon>edit</v-icon>
          </v-list-item>
          <v-list-item @click.prevent="logout">
            <v-list-item-title>Se déconnecter</v-list-item-title>
            <v-icon>logout</v-icon>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
  </v-container>
</template>

<script>
//import { mapGetters } from "vuex";
/* eslint-disable */
module.exports = {
  data() {
    return {
      navigationLinks: [
        {
          title: "Rechercher",
          link: "/search",
          icon: "search",
        },
        { title: "Publications", link: "/publications", icon: "newspaper" },
        { title: "À propos", link: "/about", icon: "info_outline" },
      ],
      items: [
        { title: "Mon profil", link: "/profile", icon: "account_circle" },
      ],
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    isAdmin() {
      if (this.currentUser && this.currentUser.role) {
        return this.currentUser.role.name === "admin";
      }
      return false;
    },
    isEditor() {
      if (this.currentUser && this.currentUser.role) {
        return (
          this.currentUser.role.name === "editor" ||
          this.currentUser.role.name === "admin"
        );
      }
      return false;
    },
  },
  methods: {
    logout() {
      if (this.$route.path !== "/") {
        this.$router.push("/");
      }

      // Effectuez les autres opérations de déconnexion ici
      this.$store.dispatch("auth/logout");
    },
  },
};
</script>

<style scoped>
.custom_title {
  font-family: "Imprima", sans-serif;
  font-size: 35px;
}
</style>
